export const itemsUnitColumns = [
    {
      Header: 'Items Id',
      accessor: 'itemsId',
    },
    {
      Header: 'Items Name',
      accessor: 'itemsName',
    },
    {
      Header: 'Short Name',
      accessor: 'shortName',
    },
    {
      Header: 'Actions',
      accessor: 'actions',
    }
  ];

  export const itemsUnitListTableData = [
    {   
        itemsId:'1101',
        itemsName:'Kilogram',
        shortName:'kg',
    },
    {   
        itemsId:'1102',
        itemsName:'Liter',
        shortName:'ltr',
    },
    {   
        itemsId:'1103',
        itemsName:'Milligram',
        shortName:'mg',
    },
    {   
        itemsId:'1104',
        itemsName:'Tonne',
        shortName:'tn',
    },
    {   
        itemsId:'1105',
        itemsName:'Gram',
        shortName:'grm',
    },
    {   
        itemsId:'1106',
        itemsName:'Per Pieces',
        shortName:'pcs',
    },
    {   
      itemsId:'1107',
      itemsName:'Per Cup',
      shortName:'cup',
    },
    {   
      itemsId:'1108',
      itemsName:'Pound',
      shortName:'pnd',
    },
]